import { recordPath, recordRoute } from '@/shared/registry'

/** Where the storage account pages live. */
export const storageAccountsPath = '/catalog/storage-accounts'
export const createStorageAccountPath = `${storageAccountsPath}/new`
export const storageAccountRoute = recordRoute('catalog', 'storage-accounts')
export const editStorageAccountRoute = `${storageAccountRoute}/edit`

/** A storage account's details page. */
export function storageAccountPath(id: string): string {
  return recordPath('catalog', 'storage-accounts', id)
}

/** The base of Storage Account Details' slots (`detailsSlots`). */
export const storageAccountDetailsSlot = 'catalog.storage-account-details'

/** The API's storage account endpoints. */
export const storageAccountsApi = '/catalog/v1/storage-accounts'

export function storageAccountApi(id: string): string {
  return `${storageAccountsApi}/${encodeURIComponent(id)}`
}

/** What each storage account action needs; creating one, or sending keys, also needs `credentials`. */
export const readStorageAccountsPermission = 'catalog.storage-accounts.read'
export const writeStorageAccountsPermission = 'catalog.storage-accounts.write'
export const deleteStorageAccountsPermission = 'catalog.storage-accounts.delete'
export const writeStorageAccountCredentialsPermission = 'catalog.storage-accounts.credentials.write'
